<script setup lang="ts">
import { useConfigurator } from '@/composables/configurator/useConfigurator'

const { experimental } = useConfigurator()
</script>

<template>
  <Experimental v-model="experimental" data-testid="experimental-tab-content" />
</template>
